import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'bh-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Baptist Health Urgent Care',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1-615-988-2000,
  email: 'support@baptisthealthurgentcare.net',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/bh/index.js